import { Link } from 'react-router'
import { siteConfig } from '../../config/site'
import type { ServiceQuestionContent } from '../../data'

interface ServiceCTAProps {
  question: ServiceQuestionContent
  showOnlinePrintCta?: boolean
}

export function ServiceCTA({ question, showOnlinePrintCta }: ServiceCTAProps) {
  return (
    <section className="service-cta" aria-labelledby="service-question-heading">
      <h2 id="service-question-heading">{question.heading}</h2>
      <p>
        {question.body}{' '}
        <a className="service-cta__phone" href={siteConfig.phoneHref}>Call {siteConfig.phone}</a>.
      </p>
      <div className="service-cta__actions">
        {showOnlinePrintCta ? (
          <a
            className="service-button service-button--print"
            href={siteConfig.onlinePrintShopUrl}
            rel="noreferrer"
          >
            Order Printing Online
          </a>
        ) : null}
        <Link className="service-button service-button--primary" to="/contact-us">Contact Us</Link>
        {question.showTrackingCta ? (
          <Link className="service-button service-button--secondary" to="/tracking">Tracking Page</Link>
        ) : null}
      </div>
    </section>
  )
}
